import { InMemoryCache, gql } from '@apollo/client';
import { isLoggedIn } from '../helpers/utils';
import { authUserInitialData } from '../graphql/resolvers/auth';
export const cache = new InMemoryCache({
  freezeResults: true
});

const INITIAL_STATE_QUERY = gql`
  query GetInitialState {
    isLoggedIn @client
    AuthUser @client
  }
`;

// Initialize the cache using writeQuery
cache.writeQuery({
  query: INITIAL_STATE_QUERY,
  data: {
    isLoggedIn: isLoggedIn(),
    AuthUser: authUserInitialData
  }
});
